<template>
  <div class="home">
    <!-- <div class="top_title">
      <van-field
        v-model="fieldValue"
        is-link
        readonly
        label=""
        placeholder="请选择您的单位"
        @click="show = true"
        class="field"
      />
    </div> -->
    <div class="hdgz">
      <div class="guize_wrap">
        <div class="huodongguize">活动规则</div>
        <p><mark>活动时间：</mark><span>11月29日—12月30日</span>（门票数量有限，兑完为止，活动根据兑奖情况可能会提前结束）。</p>
        <p><mark>答题方式：</mark>进入答题页面，按照题目要求进行答题，只要全部答对10道题即可领取门票，每人每天有3次答题机会，但奖品不叠加。</p>
        <p><mark>奖品设置：</mark>活动主办方协同参与景区，为广大网友提供景区门票千余张。参与景区：洛阳老君山，新乡八里沟、关山、万仙山，焦作神农山，三门峡陕州地坑院，南阳方城七峰山、社旗山陕会馆，安阳殷墟博物馆、殷墟宫殿宗庙遗址、殷墟考古文旅小镇、洹河夜游、曹操高陵遗址博物馆、马氏庄园、汤阴岳飞庙、羑里城等。</p>
        <p><mark>联系方式：</mark>本次活动中如有任何疑问或需要帮助，请联系张老师，联系电话：0371-65902664。</p>
        <p><mark>注：</mark>景区门票将以电子门票或纸质门票形式予以兑现。赢得门票的答题者需在选择景区后按系统要求填写信息，我们将保护个人信息安全。</p>
      </div>
      <div class="btn" @click="dati"></div>
      <!-- <div class="zjcx_wrap" @click="zjcx">
        中奖查询
      </div> -->
    </div>

    <!-- <footer_com/> -->
  
    <van-popup v-model="show" round position="bottom" closeable @close="show = false" :safe-area-inset-bottom="true">
      <van-cascader
        v-model="cascaderValue"
        title="请选择您的单位"
        :options="options"
        :field-names="fieldNames"
        @finish="onFinish"
        :closeable="false"
      />
      <div class="zhanwei"></div> 
    </van-popup>
    <van-overlay :show="showbm" z-index="999" class-name="overlay">
      <div class="wrapper po_r">
        <img src="@/assets/img/close.png" alt="" class="close" @click="close">
        <template v-if="jieguo == false">
          <div class="overlay_title">
            <span>中奖查询</span>
          </div>
          <div class="searchinp">
            <input type="tel" placeholder="请输入中奖后所填报的真实手机号码" v-model="tel" maxlength="11" minlength="11">
          </div>
          <div class="zhu">注：根据答题规则，答题人在中奖后所输入的信息不完整、不准确皆视为无效信息，均无法兑奖。</div>
          <div class="overlay_btn overlay_btn1" @click="search()">
            <!-- 提交 -->
          </div>
        </template>
        <template v-else-if="jieguo == null">
          <div class="overlay_title1">
            <span>查询结果</span>
          </div>
          <div class="jp">
            <img src="@/assets/img/404.png" alt="" class="fail_cj_404">
          </div>
          <div class="overlay_text" >
            <p>未查到相关中奖记录～</p>
          </div>
          <div class="overlay_btn" @click="close()">
            <!-- 我知道了 -->
          </div>
        </template>
        <template v-else>
          <div class="overlay_title1">
            <span>查询结果</span>
          </div>
          <!-- 
        /* address: "广东省佛山市南海区狮山镇颜峰泗和村新宅区一巷四号"
        mobile: "13798602780"
        username: "叶蔡华"
        winning: 3 */ -->
          <div class="zjinfo">
            <div class="flex">
              <p class="span">姓名：</p>
              <p>{{jieguo.username}}</p>
            </div>
            <div class="flex">
              <p class="span">电话：</p>
              <p>{{jieguo.mobile}}</p>
            </div>
            <div class="flex">
              <p class="span">地址：</p>
              <p>{{jieguo.address}}</p>
            </div>
            <div class="flex">
              <p class="span">奖品：</p>
              <p>{{jplist[jieguo.winning-1] && jplist[jieguo.winning-1].name || ''}}</p>
            </div>
          </div>
          <div class="overlay_text1" >
            <p>活动结束后20个工作日未收到奖品的中奖网友，请致电13203851958咨询。</p>
          </div>
          <div class="overlay_btn" @click="close()">
            <!-- 我知道了 -->
          </div>
        </template>
      </div>
    </van-overlay>
  </div>
</template>

<script>
/* 一等奖100名，价值200元智能节能风扇；
二等奖200名，价值100元话费充值；
三等奖2000名，价值20元定制手提袋+可降解垃圾袋 */
import footer_com from "@/components/footer_com.vue";
export default {
  name: 'Home',
  components: {
    footer_com
  },
  data(){
    return {
      showbm:false,//是否展示报名页面
      jplist:[],
      jieguo:false,
      show:false,
      tel:'',
      cascaderValue: '',
      fieldNames: {
        text: 'name',
        value: 'code',
        children: 'items',
      },
      options: [
        {
          name: '区直部门',
          code: '1',
          items: [
            { name: '纪检监察工委', code: '11' },
            { name: '党政办公室', code: '12' },
            { name: '组织人事部', code: '13' },
            { name: '党群工作部', code: '14' },
            { name: '社会事务综合协调办公室', code: '15' },
            { name: '发展和统计局（重点项目协调推进办公室）', code: '16' },
            { name: '财政金融局', code: '17' },
            { name: '招商工作部', code: '18' },
            { name: '科技工信局', code: '19' },
            { name: '建设局', code: '111' },
            { name: '生态环境和城市管理局（综合行政执法局）', code: '112' },
            { name: '自然资源和规划局', code: '113' },
            { name: '交通运输和枢纽经济发展局', code: '114' },
            { name: '市场监督管理和营商环境局', code: '120' },
            { name: '口岸管理局', code: '115' },
            { name: '教育卫生体育局', code: '116' },
            { name: '审计局', code: '117' },
            { name: '社会事业局', code: '118' },
            { name: '应急管理局', code: '119' },

          ],
        },
        {
          name: '驻区垂直单位',
          code: '2',
          items: [
            { name: '航空港区公安分局', code: '21' },
            { name: '航空港区人民法院', code: '22' },
            { name: '航空港区人民检察院', code: '23' },
            { name: '消防救援支队', code: '24' },
            { name: '税务分局', code: '25' },
          ],
        },
        {
          name: '园区管理机构',
          code: '3',
          items: [
            { name: '中原医学科学城管理委员会', code: '31' },
            { name: '先进制造业集聚区管理办公室', code: '32' },
            { name: '航空枢纽港管理办公室', code: '33' },
            { name: '国际贸易会展区管理办公室', code: '34' },
            { name: '北港总部经济和现代服务业发展区管理办公室', code: '35' },
            { name: '园博数字创意产业园管理办公室', code: '36' },
          ],
        },
        {
          name: '区直属事业单位',
          code: '4',
          items: [
            { name: '河南省科学院航空港区分院', code: '41' },
            { name: '航空航天经济发展中心', code: '42' },
            { name: '智慧城市运行中心', code: '43' },
          ],
        },
        {
          name: '国有企业',
          code: '5',
          items: [
            { name: '郑州航空港投资集团有限公司', code: '51' },
            { name: '郑州航空港科创投资集团有限公司', code: '52' },
            { name: '河南航空港发展投资集团有限公司', code: '53' },
            { name: '郑州航空大都市发展集团有限公司', code: '54' },
            { name: '郑州航空大都市研究院有限公司', code: '55' },
            { name: '河南才港人力资源服务有限公司', code: '511' },
            { name: '郑州航空港国际教育投资发展集团有限公司', code: '56' },
            { name: '郑州空中丝路文化传媒有限公司', code: '57' },
            { name: '河南中原医学科学城建设发展有限公司', code: '58' },
            { name: '河南空港数字城市开发建设有限公司', code: '59' },
            { name: '河南空港规划设计有限公司', code: '510' },
          ],
        },
        {
          name: '乡镇（办事处）、社区服务中心',
          code: '6',
          items: [
            { name: '新港办事处', code: '61' },
            { name: '郑港办事处', code: '62' },
            { name: '滨河办事处', code: '63' },
            { name: '银河办事处', code: '64' },
            { name: '张庄办事处', code: '65' },
            { name: '三官庙办事处', code: '66' },
            { name: '龙港办事处', code: '67' },
            { name: '八岗办事处', code: '68' },
            { name: '清河办事处', code: '69' },
            { name: '冯堂办事处', code: '610' },
            { name: '龙王办事处', code: '611' },
            { name: '明港办事处', code: '612' },
            { name: '八千办事处', code: '6133' },
            { name: '岗李乡', code: '614' },
            { name: '大马乡', code: '615' },
            { name: '大营镇', code: '616' },
            { name: '洧川镇', code: '617' },
            { name: 'IT产业园社区服务中心', code: '618' },
          ],
        },
      ],
      loading:false,
    }
  },
  mounted(){

    if(!localStorage.jp){
      // 3、活动奖品：一等奖50名，奖品是加湿器；二等奖200名，奖品是种子纸台历；三等奖500名，奖品是环保手提袋。
      localStorage.jp = JSON.stringify([{
        drawLevel:'一等奖',
        num:50,
        // money:'价值200元',
        name:'加湿器',
        url:'https://bm.dahe.cn/wxbanswer/img/level1.png',
      },
      {
        drawLevel:'二等奖',
        num:200,
        // money:'价值100元',
        name:'种子纸台历',
        url:'https://bm.dahe.cn/wxbanswer/img/level2.png',
      },
      {
        drawLevel:'三等奖',
        num:600,
        // money:'价值20元',
        name:'环保手提袋',
        url:'https://bm.dahe.cn/wxbanswer/img/level3.png',
      }])
    }
    this.jplist = JSON.parse(localStorage.jp)
    console.log(localStorage.jp);
  },
  methods:{
    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      this.show = false;
      this.fieldValue = selectedOptions.map((option) => option.name).join('/');
      localStorage.city =  selectedOptions[0].name || ''
      localStorage.department =  selectedOptions[1].name || ''
    },
    dati(){
      if(localStorage.userAnswer == 'false'||localStorage.userAnswer == '0'){
        this.$toast.fail('今日答题机会已用完，请明日再来');
        return
      }
      this.$router.push({
        path:'/dt',
        query:{
          type:1,
        }
      });
    },
    zjcx(){
      this.showbm = true
    },
    close(){
      this.showbm = false
      this.jieguo = false
      this.tel = ''
    },
    search(){
      if(!this.tel){
        this.$toast.fail('请输入手机号查询');
        return
      }
      if(this.tel.length != 11){
        this.$toast.fail('请输入正确的手机号查询');
        return
      }
      let obj = {
        mobile:this.tel
      }
      let toast = this.$toast.loading({
        duration:0,
        message: '查询中...',
        forbidClick: true,
        loadingType: 'spinner',
      });
      this.$store.dispatch('winninginfo',obj).then(res=>{
        this.tel = ''
        console.log(res);
        toast.clear()
        /* address: "广东省佛山市南海区狮山镇颜峰泗和村新宅区一巷四号"
        mobile: "13798602780"
        username: "叶蔡华"
        winning: 3 */
        // let res = {
        //   obj:{
        //     address:'广东省佛山市南海区狮山镇颜峰泗和村新宅区一巷四号',
        //     mobile:'13798602780',
        //     username:'叶蔡华',
        //     winning:3
        //   }
        // }
        this.jieguo = res.obj

      }).catch(()=>{
        toast.clear()
        this.$toast.fail('活动太火爆了~稍后再试');
      })
    },
  }
}



</script>
<style lang="scss" scoped>
.home{
  background: url(~@/assets/img/bg.png) top center no-repeat;
  background-size: 750px 2080px;
  width: 750px;
  min-height: 2080px;
  margin: 0 auto;
  padding-top: 960px;
  position: relative;
  .top_title{
      width: 700px;
      height: 88px;
      background: #FFFFFF;
      border-radius: 12px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
    p{
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 28px;
      color: #2B4E39;
      letter-spacing: 0;
      text-align: center;
      line-height: 42px;
    }
  }
  // padding-bottom: 200px;
  // padding-bottom:env(safe-area-inset-bottom);
  .hdgz{
    width: 100%;
    .guize_wrap{
      width: 702px;
      // height: 838px;
      border: 2px solid #295CFF;
      background: #E6EEF6;
      margin: 0 auto 0;
      border-radius: 20px;
      padding:0 56px 40px;
      .huodongguize{
        color: #e6eef6;
        font-family: "PingFang SC";
        font-size: 40px;
        font-style: normal;
        font-weight: 600;
        line-height: 52px;
        width:300px;
        border-radius: 0 0 20px 20px;
        height: 60px;
        line-height: 60px;
        background: #295CFF;
        margin: 0 auto;
        text-align: center;
        margin-bottom: 20px;
      }
      p{
        mark{
          color: #1b2a5a;
          font-family: "PingFang SC";
          font-size: 32px;
          font-style: normal;
          font-weight: 600;
          line-height: 56px;
        }
        color: #1b2a5a;
        font-family: "PingFang SC";
        font-size: 30px;
        font-style: normal;
        font-weight: 400;
        line-height: 56px;
        span{
          color: #ef9d22;
          font-family: "PingFang SC";
          font-size: 32px;
          font-style: normal;
          font-weight: 600;
          line-height: 56px;
        }
      }
    }
    // height: 912px;
    // background: url(~@/assets/img/hdgzbg.png) top center no-repeat;
    // background-size: 100% 100%;
    .hdgz_title{
      font-family: PingFangSC-SNaNpxibold;
      font-weight: 600;
      font-size: 40px;
      color: #18845B;
      letter-spacing: 0;
      line-height: 52px;
      display: block;
      margin: 0 auto;
      position: relative;
      text-align: center;
      z-index: 3;
    }
    .hdgz_content{
      margin-top: 0px;
      position: relative;
      z-index: 2;
      // background: url(~@/assets/img/hdgz_bg.png) top center no-repeat;
      // background-size: 100% 100%;
      padding: 28px 52px 28px;
      height: 1140px;
      b{
        color: #FFCE63;
      }
      p{
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 30px;
        color: #FFFFFF;
        letter-spacing: 0;
        line-height: 56px;
        &.idt{
          text-indent: 56px;
        }
        // span{
        //   font-family: PingFangSC-SNaNpxibold;
        //   // font-weight: 600;
        //   font-size: 32px;
        //   // color: #FFCE63;
        //   letter-spacing: 0;
        //   line-height: 56px;
        // }
      }
      .tixing{
        position: absolute;
        bottom: 20px;
        left: 0;
        // margin-top:80px;
        padding: 34px 64px 68px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 30px;
        color: #FFE2A3;
        letter-spacing: 0;
        line-height: 48px;
        span{
          font-family: PingFangSC-SNaNpxibold;
          font-weight: 600;
          font-size: 32px;
          color: #FFE2A3;
          letter-spacing: 0;
          line-height: 48px;
        }
      }
    }
    .btn{
      width: 702px;
      height: 112px;
      background: url(~@/assets/img/btn.png) top center no-repeat;
      background-size: cover;
      margin: 0 auto;
      margin-top: 40px;
    }
  }
}
.zjcx_wrap{
  margin-top: 20px;
  
  font-family: PingFangSC-Medium;
  font-weight: 500;
  font-size: 36px;
  color: #A85F09;
  letter-spacing: 0;
  text-align: center;
}
.footer{
  margin-top: 40px;
}

.zjcx{
  width: 134px;
  height: 44px;
  display: block;
  margin: 0 auto;
}

.zhu{
  width: 524px;
  height: 120px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 28px;
  color: #B4B4B4;
  letter-spacing: 0;
  text-align: justify;
  line-height: 40px;
  margin: 0 auto 60px;
  
}

  .overlay{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .wrapper{
    width: 642px;
    height: 842px;
    // max-height: 800px;
    // background-image: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 72%, #D8FFF3 100%);
    background: url("~@/assets/img/jgalert.png") no-repeat;
    background-size: 100% 100%;
    border-radius: 20px;
    padding: 75px 50px 0;
    .jp{
      margin: 16px auto;
      .jp_pic{
        width: 462px;
        height: 292px;
        margin: 0 auto;
        display: block;
      }
      .fail_cj{
        width: 158px;
        height: 240px;
        margin: 0 auto;
        display: block;
      }
      .fail_cj_404{
        width: 362px;
        height: 196px;
        margin: 0 auto;
        display: block;
      }
      p{
        font-size: 26px;
        color: #999;
        text-align: center;
        margin-top: 16px;
      }
    }
    .close{
      width: 30px;
      height: 30px;
      display: block;
      position: absolute;
      right:28px;
      top: 44px;
    }
    .overlay_title{
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      font-size: 38px;
      letter-spacing: 0;
      height: 42px;
      line-height: 42px;
      color: #F3703B;
      margin-bottom: 0px;
      text-align: center;
      span{
        position: relative;
        // &::after{
        //   content: '';
        //   background-image: linear-gradient(90deg, #f36f3b9a 0%, #fff 100%);
        //   width: 80px;
        //   height: 8px;
        //   left: -90px;
        //   top: 27px;
        //   display: block;
        //   position: absolute;
        // }
        // &::before{
        //   content: '';
        //   background-image: linear-gradient(-90deg, #f36f3b9a 0%, #fff 100%);
        //   width: 80px;
        //   height: 8px;
        //   right: -90px;
        //   top: 27px;
        //   display: block;
        //   position: absolute;
        // }
      }
    }
    .overlay_title1{
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      font-size: 42px;
      letter-spacing: 0;
      height: 42px;
      line-height: 42px;
      color: #F3703B;
      margin-bottom: 40px;
      text-align: center;
    }
    .overlay_btn{
      width: 332px;
      height: 104px;
      line-height: 104px;
      // background-image: linear-gradient(102deg, #0EE481 0%, #0CD391 35%, #07A5E2 93%);
      background: url("~@/assets/img/zd_btn.png") no-repeat;
      background-size: cover;
      border-radius: 58px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      font-size: 32px;
      color: #FFFFFF;
      letter-spacing: 0.4;
      text-align: center;
      margin:0  auto;
    }
    .overlay_btn1{
      background: url("~@/assets/img/subtj_btn.png") no-repeat;
      background-size: cover;
    }
    .overlay_text{
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 32px;
      color: #666666;
      letter-spacing: -0.48px;
      text-align: center;
      line-height: 44px;
      margin-top:20px;
      margin-bottom: 60px;
    }
    .overlay_text1{
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 26px;
      color: #666666;
      letter-spacing: -0.48px;
      text-align: center;
      line-height: 44px;
      margin-top:20px;
      margin-bottom: 60px;
      text-indent: 2em;
      p{
        text-align: left;
      }
    }
  }
  /deep/{
  .van-notice-bar__content{
    font-weight: 400;
    font-size: 0.3733rem;
    color: #000000;
    letter-spacing: 0;
  }
    .van-notice-bar{
      height: 1.1467rem;
      padding: 0 0.24rem;
    }
    .van-swipe__indicator{
      border-radius: 0.08rem;
      width: 0.32rem;
      height: 0.16rem;
    }
    .van-swipe__indicator--active{
      width: 0.5067rem;
    }
  }


  .searchinp{
    margin: 90px auto 48px;
    input{
      width: 546px;
      height: 92px;
      background: #F0F0F0;
      border-radius: 10px;
      font-weight: 400;
      font-size: 30px;
      color: #333;
      letter-spacing: 0;
      padding: 0 34px;
    }
  }
  .zjinfo{
    // width: 582px;
    // height: 316px;
    background-image: linear-gradient(203deg, #FFFAE5 0%, #F6E5C3 100%);
    border-radius: 10px;
    margin: 26px auto 50px;
    padding: 14px 32px;

    .flex{
      margin: 20px 0;
    }
    p{
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 32px;
      color: #121212;
      letter-spacing: 0;
      &.span{
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 30px;
        color: #958666;
        letter-spacing: 0;
        flex-shrink: 0;
        flex-grow: 0;
      }
    }
  }
  .zhanwei{
    height: 20px;
  }
</style>
